import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=abd151a2&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abd151a2')) {
      api.createRecord('abd151a2', component.options)
    } else {
      api.reload('abd151a2', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=abd151a2&", function () {
      api.rerender('abd151a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0LlPeIvmngg/JS/pricelisthelp.vue"
export default component.exports